<template>
  <div class="animated fadeIn">
    <b-modal
      ref="remnantModal"
      lazy
      ok-only
      :title="modalTitle"
      size="lg"
      @hidden="remnantModalClose()"
    >
      <component
        :is="remnantBasicComponent"
        :email="modalEmail"
        :read-only="true"
      />
    </b-modal>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>최종 확정 리스트</strong>
          </div>
          <b-row>
            <b-col
              md="5"
              class="text-left"
            >
              <b-input-group
                name="partSet"
                prepend="연도"
                label-for="part"
                class="mb-2"
              >
                <b-form-select
                  v-model="term"
                  :disabled="noAuth"
                  :options="termOptions"
                  @change="getFinalListTerm"
                />
              </b-input-group>
            </b-col>
            <b-col
              md="5"
              class="text-left"
            >
              <b-input-group
                name="partSet"
                prepend="부서"
                label-for="part"
                class="mb-2"
              >
                <b-form-select
                  v-model="part"
                  :disabled="noAuth"
                  :options="partOptions"
                  @change="getFinalList"
                />
                <b-input-group-append>
                  <b-btn
                    variant="primary"
                    :disabled="noAuth"
                    size="sm"
                    @click="getFinalList(part)"
                  >
                    새로고침
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="2">
              <json-excel
                :data="itemAll"
                :fields="excel.field"
                worksheet="최종"
                :name="'최종_' + part + '.xls'"
                :footer="excel.footer"
                :before-generate="excelBeforeGenerate"
              >
                <b-button variant="outline-success">
                  Excel
                </b-button>
              </json-excel>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col
              md="4"
            >
              <b-form-group
                label="Per page"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <h4>
                <b-badge
                  variant="dark"
                >
                  <strong>Total: {{ totalRows }}</strong>
                </b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            class="text-center"
          >
            <b-table
              class="mb-0 table-outline"
              head-variant="light"
              hover
              :items="itemAll"
              :fields="fieldsAll"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template
                v-slot:cell(part)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(name)="data"
              >
                <b-button
                  variant="outline-success"
                  size="md"
                  @click="showRowDetail(data.item._showDetails, data.item.applyId)"
                >
                  <b>{{ data.value }}</b>
                  <b-badge
                    v-if="data.item.longterm > 2"
                    variant="primary"
                  >
                    장기B
                  </b-badge>
                  <b-badge
                    v-else-if="data.item.longterm > 0"
                    variant="primary"
                  >
                    장기A
                  </b-badge>
                </b-button>
              </template>
              <template
                v-slot:cell(title)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(amount)="data"
              >
                <div>
                  {{ toCurrency(Number(data.value)) }}
                </div>
              </template>
              <template
                v-slot:row-details="row"
              >
                <div class="animated fadeIn">
                  <b-row align-h="end">
                    <b-col md="2">
                      <b-button
                        size="sm"
                        @click="generateInfo(row.item.name)"
                      >
                        Print Info
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
                <div
                  ref="printMe"
                  class="print-me"
                >
                  <div class="animated fadeIn">
                    <b-row>
                      <b-col md="12">
                        <h3>장학생 정보</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2">
                        <img
                          crossOrigin="anonymous"
                          :src="serverUri + '/cdn/img?id=' + row.item.photo + '&email=' + row.item.email"
                          class="photobox img-responsive img-thumbnail"
                        >
                      </b-col>
                      <b-col
                        md="10"
                        align-content="start"
                        class="text-left"
                      >
                        <b-row>
                          <b-col md="12">
                            <b>{{ row.item.name }}</b>
                            <span v-show="row.item.kid !== '아님'">{{ row.item.kid }}</span>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3">
                            출석교회: {{ row.item.church }}
                          </b-col>
                          <b-col md="2">
                            부서: {{ row.item.part }}
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3">
                            학교: {{ row.item.school }}
                          </b-col>
                          <b-col md="2">
                            학년: {{ row.item.grade }}
                          </b-col>
                          <b-col md="2">
                            전공: {{ row.item.major }}
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row v-if="row.item.longterm > 0">
                      <b-col
                        md="12"
                        class="text-left"
                      >
                        <span class="textbox">
                          보고서: {{ row.item.longtermReport }}
                        </span>
                      </b-col>
                    </b-row>
                    <b-row v-else>
                      <b-col
                        md="12"
                        class="text-left"
                      >
                        <span class="textbox">
                          {{ nameForTopic1 }}: {{ row.item.topic1 }}
                        </span>
                      </b-col>
                      <b-col md="12">
                        <hr>
                      </b-col>
                      <b-col
                        md="12"
                        class="text-left"
                      >
                        <span class="textbox">
                          {{ nameForTopic2 }}: {{ row.item.topic2 }}
                        </span>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </template>
            </b-table>
          </b-row>
          <b-row
            align-h="center"
            class="my-1"
          >
            <b-col
              cols="5"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="12"
              class="text-left"
            >
              보고서 제출 안한 장기장학생:
              <h5>
                <b-badge
                  v-for="(rt, email) in missedLongterm"
                  :key="email"
                  href="#"
                  variant="warning"
                  @click="remnantModalShow(email, rt)"
                >
                  {{ rt }}
                </b-badge>
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <hr>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col md="6">
              <b-row no-gutters>
                <b-col md="4">
                  <b-input-group prepend="지정">
                    <b-form-input
                      :readonly="true"
                      :placeholder="remnantDonate"
                    />
                  </b-input-group>
                </b-col>
                <b-col md="4">
                  <b-input-group prepend="TOP">
                    <b-form-input
                      :readonly="true"
                      :placeholder="remnantTop"
                    />
                  </b-input-group>
                </b-col>
                <b-col md="4">
                  <b-input-group prepend="SUMMIT">
                    <b-form-input
                      :readonly="true"
                      :placeholder="remnantSummit"
                    />
                  </b-input-group>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col md="12">
                  <b-input-group prepend="전체">
                    <b-form-input
                      :readonly="true"
                      :placeholder="remnantTotal"
                    />
                  </b-input-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row no-gutters>
                <b-col md="6">
                  <b-input-group prepend="지정">
                    <b-form-input
                      :readonly="true"
                      :placeholder="toCurrency(amountDonate)"
                    />
                  </b-input-group>
                </b-col>
                <b-col md="6">
                  <b-input-group prepend="교회">
                    <b-form-input
                      :readonly="true"
                      :placeholder="toCurrency(amountChurch)"
                    />
                  </b-input-group>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col md="12">
                  <b-input-group prepend="전체">
                    <b-form-input
                      :readonly="true"
                      :placeholder="toCurrency(amountTotal)"
                    />
                  </b-input-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import RemnantBasic from './remnant/RemnantBasic'
import api from '../api'
import JsPdf from 'jspdf'
import Dom2Image from 'dom-to-image'
import JsonExcel from 'vue-json-excel'

export default {
  name: 'FinalList',
  components: { JsonExcel, RemnantBasic },
  data: function () {
    return {
      filter: null,
      filterOn: ['name', 'title'],
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 15, 20, 50, 100],
      part: '권한없음',
      partOptions: [],
      noAuth: false,
      modalTitle: '',
      modalEmail: '',
      term: '',
      termOptions: [],
      itemAll: [],
      serverUri: api.serverURI,
      missedLongterm: {},
      remnantBasicComponent: null,
      excel: {
        footer: [],
        field: {
          '부서': 'part',
          '이름': 'name',
          '장학종류': {
            field: 'title',
            callback: (value) => {
              if (value !== 'TOP' && value !== 'SUMMIT') {
                return '지정기탁'
              }
              return value
            }
          },
          '장학금이름': {
            field: 'title',
            callback: (value) => {
              return value
            }
          },
          '기탁장학금송금명': {
            field: 'sender',
            callback: (value) => {
              if (value === '') {
                value = '교회'
              }
              return value
            }
          },
          '금액': {
            field: 'amount',
            callback: (value) => {
              return this.toCurrency(Number(value))
            }
          },
          '대상자계좌번호': 'account',
          '대상자계좌주': 'accountHolder'
        }
      },
      fieldsAll: [
        {
          key: 'part',
          label: '부서',
          sortable: true
        },
        {
          key: 'name',
          label: '이름',
          sortable: true
        },
        {
          key: 'title',
          label: '장학생',
          sortable: true
        },
        {
          key: 'amount',
          label: '금액',
          sortable: false
        }
      ]
    }
  },
  computed: {
    nameForTopic1 () {
      return api.nameTopic1(this.term)
    },
    nameForTopic2 () {
      return api.nameTopic2(this.term)
    },
    freezing () {
      if (api.currentTerm() !== this.term) {
        return true
      }
      return false
    },
    amountTotal () {
      let total = 0
      this.itemAll.forEach(item => {
        total += item.amount
      })
      return total
    },
    amountChurch () {
      let total = 0
      this.itemAll.forEach(item => {
        if (item.title === 'TOP' || item.title === 'SUMMIT') {
          total += item.amount
        }
      })
      return total
    },
    amountDonate () {
      let total = 0
      this.itemAll.forEach(item => {
        if (item.title !== 'TOP' && item.title !== 'SUMMIT') {
          total += item.amount
        }
      })
      return total
    },
    remnantTotal () {
      return String(this.itemAll.length)
    },
    remnantDonate () {
      let cnt = 0
      this.itemAll.forEach(item => {
        if (item.title !== 'TOP' && item.title !== 'SUMMIT') {
          cnt += 1
        }
      })
      return String(cnt)
    },
    remnantTop () {
      let cnt = 0
      this.itemAll.forEach(item => {
        if (item.title === 'TOP') {
          cnt += 1
        }
      })
      return String(cnt)
    },
    remnantSummit () {
      let cnt = 0
      this.itemAll.forEach(item => {
        if (item.title === 'SUMMIT') {
          cnt += 1
        }
      })
      return String(cnt)
    }
  },
  mounted () {
    if (this.$store.getters.isSuper) {
      this.getPartTable()
      this.getTermList()
    } else {
      this.noAuth = true
      this.part = '권한없음'
      this.$router.push('/dashboard')
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    toCurrency (value) {
      if (typeof value !== 'number') {
        return value
      }
      var formatter = new Intl.NumberFormat('ko-KR', {
        style: 'currency',
        currency: 'KRW',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    remnantModalClose () {
      this.remnantBasicComponent = null
    },
    remnantModalShow (email, rt) {
      this.modalTitle = rt + ' 정보'
      this.modalEmail = email
      this.remnantBasicComponent = RemnantBasic
      this.$refs.remnantModal.show()
    },
    excelBeforeGenerate () {
      let foot = []
      let line = ''
      foot.push(line)
      line = '지정기탁  인원: ' + this.remnantDonate + '명'
      line += ' / TOP     인원: ' + this.remnantTop + '명'
      line += ' / SUMMIT  인원: ' + this.remnantSummit + '명'
      foot.push(line)
      foot.push('전체     인원: ' + this.remnantTotal + '명')
      line = '지정기탁  금액: ' + this.toCurrency(this.amountDonate) + '원'
      line += ' / 비지정   금액: ' + this.toCurrency(this.amountChurch) + '원'
      foot.push(line)
      foot.push('전체     금액: ' + this.toCurrency(this.amountTotal) + '원')
      this.excel.footer = foot
    },
    generateInfo (name) {
      let pdf = new JsPdf('p', 'mm', 'a4')
      let canvas = pdf.canvas
      const pageWidth = 190 // 캔버스 너비 mm 210 - 20
      const pageHeight = 295 // 캔버스 높이 mm
      canvas.width = pageWidth
      let ele = this.$refs.printMe
      let width = ele.offsetWidth // 셀렉트한 요소의 px 너비
      let height = ele.offsetHeight // 셀렉트한 요소의 px 높이
      let imgHeight = pageWidth * height / width // 이미지 높이값 px to mm 변환
      Dom2Image.toPng(ele)
        .then(imgUrl => {
          let position = 10
          const imgData = imgUrl
          pdf.addImage(imgData, 'png', 10, position, pageWidth, imgHeight, undefined, 'slow')
          // Paging 처리
          let heightLeft = imgHeight // 페이징 처리를 위해 남은 페이지 높이 세팅.
          heightLeft -= pageHeight
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight
            pdf.addPage()
            pdf.addImage(imgData, 'png', 10, position, pageWidth, imgHeight)
            heightLeft -= pageHeight
          }
          // pdf.output('dataurlnewwindow')
          pdf.save('장학생_' + name + '.pdf')
        }).catch((error) => {
          console.log(error)
          alert('Error to make a pdf', error)
        })
    },
    parseFinal (data) {
      this.itemAll = []
      data.forEach(elem => {
        var item = {}
        item['part'] = elem.part
        item['name'] = elem.name
        item['sender'] = elem.sender
        item['title'] = elem.title
        item['amount'] = elem.amount
        item['longterm'] = elem.longterm
        item['its'] = api.ITSDETAIL[elem.its].split('(')[0].substring(2)
        /* hidden */
        item['account'] = '(' + elem.bank + ')' + elem.account
        item['accountHolder'] = elem.accountHolder
        item['email'] = elem.email
        item['applyId'] = elem.applyId
        item['school'] = elem.school
        item['major'] = elem.major
        item['grade'] = elem.grade
        item['photo'] = elem.photo
        item['church'] = elem.church
        item['kid'] = elem.kid
        item['_showDetails'] = false
        this.itemAll.push(item)
      })
      this.totalRows = this.itemAll.length
    },
    getPartTable () {
      api.request('get', '/auth/part?' + 'auth=' + this.$store.getters.authName)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          this.partOptions = data.partTable
          if (this.partOptions.length > 0) {
            this.part = this.partOptions[0]
          } else {
            this.part = '권한없음'
            this.noAuth = true
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    showRowDetail (val, id) {
      this.itemAll.forEach(row => {
        if (row.applyId === id) {
          /* apply중에서 긴 내용들만 가져옴 */
          api.request('get', '/apply/check?applyId=' + id + '&info=1&ic=detail')
            .then(response => {
              var data = response.data
              row['topic1'] = data.topic1
              row['topic2'] = data.topic2
              row['longtermReport'] = data.longtermReport
              row._showDetails = !val
            })
            .catch(error => {
              alert(error.response.data.error)
              row._showDetails = false
            })
        } else {
          row._showDetails = false
        }
      })
    },
    getFinalList (part) {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/admin/final/list?part=' + part + '&term=' + this.term)
        .then(response => {
          var data = response.data
          this.missedLongterm = data.missedLongterm
          this.parseFinal(data.docs)
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    },
    getFinalListTerm (term) {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/admin/final/list?part=' + this.part + '&term=' + term)
        .then(response => {
          var data = response.data
          this.missedLongterm = data.missedLongterm
          this.parseFinal(data.docs)
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    },
    getTermList () {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/auth/termlist?auth=' + this.$store.state.AUTH)
        .then(response => {
          var data = response.data
          /* result term */
          this.termOptions = []
          data.terms.forEach(term => {
            this.termOptions.push(term)
          })
          if (this.termOptions.length > 0) {
            this.term = this.termOptions[0]
          } else {
            // 권한 없음
            this.noAuth = true
          }
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    }
  }
}
</script>

<style scoped>
.photobox {
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  max-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.print-me {
  font-size: 20px;
}
.textbox {
  word-break: break-all;
}
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
